import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { FolderFavorite } from '@/types/api';

export const favoritesQueryKey = ['favorites', 'folders'] as const;

export function useFolderFavorites() {
  return useQuery({
    queryKey: favoritesQueryKey,
    queryFn: async () =>
      (await api.get<FolderFavorite[]>('/me/favorites/folders')).data,
  });
}

export function useAddFolderFavorite() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (folderId: string) => {
      const { data } = await api.post<FolderFavorite>(
        `/me/favorites/folders/${folderId}`,
      );
      return data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['favorites'] });
    },
  });
}

export function useRemoveFolderFavorite() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (folderId: string) => {
      await api.delete(`/me/favorites/folders/${folderId}`);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['favorites'] });
    },
  });
}
